export default {
  ADDRESS: 'address',
  ADDRESS_2: 'address2',
  ANNUAL_INCOME: 'annualIncome',
  CITY: 'city',
  DATE_OF_BIRTH: 'dateOfBirth',
  EMAIL: 'email',
  FIRST_NAME: 'firstName',
  INTEREST: 'interest',
  LAST_NAME: 'lastName',
  OCCUPATION: 'occupation',
  ORIGIN_OF_AWARENESS: 'originOfAwareness',
  PASSWORD: 'password',
  PAY_TYPE: 'payType',
  PHONE: 'phone',
  PROMO_CODE: 'promoCode',
  VERIFY_PHONE: 'phone_verification_code',
  VERIFY_EMAIL: 'emailVerificationCode',
  SOURCE_OF_INCOME: 'sourceOfIncome',
  SSN: 'ssn',
  SSN_CONFIRMATION: 'ssnConfirmation',
  SSN_LAST_4: 'ssnLastFour',
  STATE: 'state',
  ZIP_CODE: 'zipcode',
  NEXT_ONBOARDING_PAGE: 'nextOnboardingPage',
  ECBSV_CONSENT: 'ecbsv_consent',
  MANDATORY_ECBSV: 'mandatory_ecbsv',
  MARKETING_SMS_CONSENT: 'marketing_sms_consented',
  CARD_PRODUCT_NAME: 'card_product_name',
};
